var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 1.965c5.542 0 10.034 4.492 10.034 10.034s-4.492 10.034-10.034 10.034S1.967 17.541 1.967 12 6.459 1.965 12 1.965M3.188 12.599a8.835 8.835 0 0 0 7.45 8.128A15.03 15.03 0 0 1 7.653 12.6zm13.162 0a15.03 15.03 0 0 1-2.987 8.128 8.834 8.834 0 0 0 7.45-8.128zm-7.497 0A13.84 13.84 0 0 0 12 20.518a13.83 13.83 0 0 0 3.147-7.92zm4.51-9.33a15.03 15.03 0 0 1 2.987 8.13h4.462a8.836 8.836 0 0 0-7.45-8.13M12 3.479a13.84 13.84 0 0 0-3.148 7.92h6.295A13.83 13.83 0 0 0 12 3.48m-1.362-.21a8.836 8.836 0 0 0-7.45 8.13h4.463a15.03 15.03 0 0 1 2.987-8.13"
  })));
};
export default SvgGlobe;